module.exports = __webpack_public_path__ + "img/youtube-icon.0545c880.svg";